import { Brand } from '@blade/std-lib'

export const TxSerializedTypeId = 'tradebot-tma/TxSerialized'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TxSerializedTypeId = typeof TxSerializedTypeId

export type TxSerialized = Brand.Branded<string, TxSerializedTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TxSerialized = Brand.nominal<TxSerialized>()
